import { TemplateResult, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { OutlineAccordion } from 'src/components/base/outline-accordion/outline-accordion';

/**
 * The IdbFacetBlock component
 * @element idb-facet-block
 *
 * @slot panels = slot for an individual facet panel: <idb-facet-panel>
 */
@customElement('idb-facet-block')
export class IdbFacetBlock extends OutlineAccordion {
  connectedCallback(): void {
    super.connectedCallback();
    this.allOpen = true;
    this.clean = true;
  }

  render(): TemplateResult {
    return html`
      <div class="wrapper">
        <div class="facet-block accordion" @keydown=${this.handleKeyboardNav}>
          <slot name="panels"></slot>
        </div>
      </div>
    `;
  }
}
